import { lineTotal } from "./escpos";

const KEY = "velta_offline_sales_v1";
const CLOSURE_KEY = "velta_offline_closures_v1";
export const QUEUE_EVENT = "velta-offline-queue";

export function newOfflineId() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  } catch { /* ignore */ }
  return `off-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function saleTotal(lines, discountPct = 0, discountEur = 0) {
  const gross = (Array.isArray(lines) ? lines : []).reduce((s, l) => s + lineTotal(l), 0);
  const pct = Number(discountPct) || 0;
  const eurD = Math.max(0, Number(discountEur) || 0);
  const totalDisc = gross * (pct / 100) + Math.min(eurD, Math.max(0, gross * (1 - pct / 100)));
  return Math.max(0, Math.round((gross - totalDisc) * 100) / 100);
}

export function readQueue() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
}

function writeQueue(items) {
  try {
    localStorage.setItem(KEY, JSON.stringify(items));
  } catch { /* quota: la vendita resta in memoria solo per questo tentativo */ }
  try {
    window.dispatchEvent(new Event(QUEUE_EVENT));
  } catch { /* ignore */ }
}

export function pendingCount() {
  return readQueue().length;
}

export function enqueueSale(item) {
  if (!item?.offline_id) return;
  const items = readQueue().filter((x) => x.offline_id !== item.offline_id);
  items.push(item);
  writeQueue(items);
}

export function removeSale(offlineId) {
  writeQueue(readQueue().filter((x) => x.offline_id !== offlineId));
}

export function readClosureQueue() {
  try {
    const raw = JSON.parse(localStorage.getItem(CLOSURE_KEY) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
}

function writeClosureQueue(items) {
  try {
    localStorage.setItem(CLOSURE_KEY, JSON.stringify(items));
  } catch { /* ignore */ }
  try {
    window.dispatchEvent(new Event(QUEUE_EVENT));
  } catch { /* ignore */ }
}

export function pendingClosureCount() {
  return readClosureQueue().length;
}

export function enqueueClosure(item) {
  if (!item?.offline_id) return;
  const items = readClosureQueue().filter((x) => x.offline_id !== item.offline_id);
  items.push(item);
  writeClosureQueue(items);
}

export function removeClosure(offlineId) {
  writeClosureQueue(readClosureQueue().filter((x) => x.offline_id !== offlineId));
}
